import { useContext } from "react"
import { Globalinfo } from "../App"


// export const BASE_URL = 'https://gr-backend-temp.onrender.com/'
export const BASE_URL = 'https://api.hopingminds.co.in/'
// export const BASE_URL = 'http://localhost:3000/'





